import Image from "next/image";
import Link from "next/link";

export default function FriendCard({
  href = "",
  name = "",
  role = "",
  image = "",
}: // image,
{
  href?: string;
  name?: string;
  role?: string;
  image?: string;
}) {
  return (
    <Link
      href={href || ""}
      target="_blank"
      className="bg-primary dark:bg-[#45c3dc] rounded-2xl shadow-sm shadow-primary dark:shadow-[#45c3dc]"
    >
      <div className="group overflow-hidden relative hover:duration-500 hover:rotate-6 flex justify-center items-center h-56 w-80 rounded-2xl">
        <Image
          alt={name}
          src={image}
          width={0}
          height={0}
          sizes="100vw"
          className="w-full h-full object-cover"
        />
        <div className="absolute w-full h-full z-10 flex flex-col items-center justify-center gap-2 bg-[#00000056]">
          <span className="text-main-gray text-3xl font-bold">{name}</span>
          <p className="text-gray-50">{role}</p>
        </div>
      </div>
    </Link>
  );
}
